import React, { useEffect, useState } from 'react'
import axios from '../../data/http/axios'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import { useSelector, useDispatch } from 'react-redux';

export default function SocketMultiUsersCampaign({ type = "campaign" }) {

    const user = useSelector((state) => state.user)

    const [justMe, setJustMe] = useState({})
    const [accountUsers, setAccountUsers] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getAccountUsers();
        if (user.usersOnSamePage) {
            const justMe = user.usersOnSamePage.filter((socketUser) => socketUser.accountUserId != user.accountUserId).length == 0
            setJustMe(justMe)
        }
    }, [])

    const getAccountUsers = async () => {
        const accountUserData = await axios.get('/accountUser');
        if (accountUserData && accountUserData.data) {
            setAccountUsers(accountUserData.data.AccountUsers)
        }
        setLoading(false);
    }

    if (loading) {
        return <></>
    }
    const justMeClass = type == "campaign" ? "" : "dragDropToolBar socketMultiUsersRightAlign";

    if (justMe) {
        return <div className={justMeClass}>
            <Hint place="bottom" style={{ margin: '0' }} tooltip={`Editing in multiple places can cause changes to be lost or overwritten. To avoid losing changes, close extra tabs or devices that are editing this ${type}.`}>
                <Icons className="mar-r5" icon={"warning"} style={{ width: 20, height: 20 }} color="#e2ab1e" />
                You are editing this {type} on multiple tabs or devices
            </Hint>

        </div>
    }

    const outerHolderClass = type == "campaign" ? "socketMultiUsersHolder" : "socketMultiUsersHolder dragDropToolBar socketMultiUsersRightAlign";
    return (
        <div className={outerHolderClass}>
            <Hint place="bottom" style={{ margin: '0' }} tooltip={`To avoid losing changes only one user should edit this ${type} at a time.`}>
                <Icons className="mar-r5" icon={"warning"} style={{ width: 20, height: 20 }} color="#e2ab1e" />
                Multiple users are editing this {type}
            </Hint>
            <div className="socketMultiUsersAvatars">
                <div className="socketMultiUsersAvatar" key={"av_me"} >
                    <Avatar
                        style={{height: 30, width: 30}}
                        key={"av_me"}
                        for={"av_me"}
                        src={user?.userData?.profilePicFileName}
                        tooltip={user?.userData?.fullname}
                    />

                </div>
                {user.usersOnSamePage.map((user, index) => {
                    let userAccount = accountUsers.find((acUser) => acUser.id == user.accountUserId)
                    return (
                        <div className="socketMultiUsersAvatar" key={index} >
                            <Avatar
                                style={{width: 30, height: 30}}
                                key={"av_" + index}
                                for={"av_" + index}
                                src={userAccount?.profilePicFileName}
                                tooltip={userAccount?.fullname}
                            />

                        </div>
                    )
                })
                }
            </div>
        </div >
    )
}